export function undefBool(bool: boolean | undefined): boolean | undefined {
  return bool || undefined;
}

export function undefBoolObj(
  bool: boolean | undefined,
  property: string
): Record<string, boolean> {
  return bool ? { [property]: true } : {};
}
